//
// Generated class SupportTag
//

/// <reference path="SupportTag_ManagedObject.ts" />

class SupportTag extends SupportTag_ManagedObject
{

}
